import './style.scss';

import React from 'react';
import SauceyLogo from 'images/saucey.svg?react-svg';
import ValueProps from 'components/home/landingPage/valueProps';
import Media from 'components/home/landingPage/media';
import Footer from 'components/footer';
import View from 'components/ui/view';

function AuthPageContainer(props) {
  return (
    <div className="signup-page">
      <div id="signup-page__header">
        <div className="row center-xs start-sm">
          <div className="col-xs-12">
            <a href="/" className="signup-page__logo">
              <SauceyLogo width={120} height={21} />
            </a>

            {props.renderNav()}
          </div>
        </div>
      </div>

      <div className="signup-page__container">
        <View className="signup-page__main" margin="xs">
          <div className="signup-page__form-container">{props.children}</div>
        </View>

        {props.renderFooter()}

        <View padding="md" margin="md" className="text-center">
          <ValueProps />
        </View>

        <Media />
      </div>

      <Footer />
    </div>
  );
}

export default AuthPageContainer;



// WEBPACK FOOTER //
// ./shared/components/authPages/container.js